import moment from 'moment';
export default {
	formatAmount(amount) {
        if (amount === null) {
			return 'Rs. 0';
		}
		return 'Rs. ' + Number(amount).toLocaleString();
	},
	validateMobile(num) {
		const validateRegex = /^((\+92)|(0092)|(92))-{0,1}\d{3}-{0,1}\d{7}$|^\d{11}$|^\d{4}-\d{7}$/;
		return validateRegex.test(num);
	},
    formatDate(date) {
        return moment(date).format('YYYY-MM-DD hh:mm A');
    },
	formatNumber(num) {
		return '+92' + (num.replace(/\([0-9]+?\)/, '')
			.replace(/[^0-9]/, '')
			.ltrim('0')
			.ltrim('+')
			.ltrim('9')
			.ltrim('2'));
	},
};
